import { EpisodeTextColumnKey } from './episodeTextImportTypes';

export type EpisodeTextImportCommandKeyValue = {
  pattern: RegExp,
  scope: EpisodeTextColumnKey[],
};

export const COMMAND_KEY_PATTERN = /(#\w+|#-+.*? )/g;

/**
 * Maps internal expression values to their canonical command names.
 * Needed because some expression values differ from command names (e.g. 'evil' → 'wicked').
 */
export const EXPRESSION_VALUE_TO_COMMAND: Record<string, string> = {
  evil: 'wicked',
};

export const episodeTextImportCommandKeyGotoValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#GOTO|#->)(?:[:\s]+)?([A-Za-z0-9_]+)?/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyStepChoiceValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#CHOICE)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
  {
    pattern: /(#-\?)(:)?[:\s]?/,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyLocationValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#LOCATION|#-L)(?:[:\s]+)?([^#]*)/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyStepChatValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#CHAT|#-C)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyStepThinkValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#THOUGHTFUL|#THOUGHT|#-TF)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyStepReactValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#REACT|#-R)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionAnxiousValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#ANXIOUS)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionBlushValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#BLUSH)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionBoredValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#BORED)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionDelightValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#DELIGHT)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionDisgustValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#DISGUST)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionFlirtingValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#FLIRTING)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionHappyValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#HAPPY)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionNeutralValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#NEUTRAL)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionRageValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#RAGE)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionSadValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#SAD)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionScaredValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#SCARED)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionShockValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#SHOCK)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionSmileValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#SMILE)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionThinkingValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#THINKING|#THINK)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyExpressionWickedValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#WICKED|#EVIL)(?=[:\s]|$)[:\s]?/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyStepRememberValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#REMEMBER)[:\s]*((?:memory\.)?\w*)\s*(view)\s*(?:\[\s*([^\]]*?)\s*\]|([^#]*?)(?=#|$))/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
  {
    pattern: /(#REMEMBER)[:\s]*((?:memory\.)?\w*)\s*([-+=])?\s*(.*)/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
];

/*
  Random command groups:
  Range: [1]=RANDOM, [2]=varName, [3]=operator, [4]=min, [5]=max, [6]=modifier (optional)
  Dice: [1]=RANDOM, [2]=varName, [3]='dice', [4]=diceNotation
  Note: Order matters - more specific patterns first, catch-all pattern last
*/
export const episodeTextImportCommandKeyStepRandomValue: EpisodeTextImportCommandKeyValue[] = [
  {
    // Range with optional modifier: #random varName operator [min, max] modifier value
    pattern: /(#RANDOM)[:\s]*(\w+)\s*([-+=])\s*\[\s*(-?\d+)\s*,\s*(-?\d+)\s*\](?:\s+modifier\s+([-+]?\d+))?/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
  {
    // Dice notation: #random varName dice notation (supports complex notation like 4d10kh2, 2d6r=5, etc.)
    pattern: /(#RANDOM)[:\s]*(\w+)\s+(dice)\s+([\w\d+\-*\/()!<>=]+)/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
  {
    // Catch-all pattern for command recognition (allows validation to pass even if syntax is wrong)
    pattern: /(#RANDOM)[:\s]*(.*)/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
];

/*
  Groups:
  Single: if: 2, memory: 3, symbol operator: 4, text operator: 5, compareMemory: 6, true node: 8, false node: 10
  Multi: min/max/lowest/highest: 2, memories: 5, gotoNodes: 6
  ConditionList: CONDITIONS: 2, variable: 3
 */
export const episodeTextImportCommandKeyStepCheckValue: EpisodeTextImportCommandKeyValue[] = [
  {
    // pattern: /(#CHECK)[:\s]*(if)\s*\((\w*)?\s*(=|<>|>=|<=|<|>)?(Exactly|Not exactly|More than|At least|Less than|At most)?\s*(.*)?\)\s*(then)?\s(\w*)?\s*(else)?\s*(#?\w*)?/i,
    pattern: /(#CHECK):*\s*(if\s+((?:memory\.)?\w*)\s*(=|<>|>=|<=|<|>)?(?![=<>])(Exactly|Not exactly|More than|At least|Less than|At most)?\s*['"]?(.*?)['"]?\s*)\s*,\s*((?:if\s+)?(?:yes(?:\s+goto)?\s+)?(\w*))\s*,\s*((?:if\s+)?(?:no(?:\s+goto)?\s+)?(\w*))/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
  {
    // pattern: /(#CHECK)[:\s]*(Min|Max)?(Lowest|Highest)?\(([^)]+)\)\s*(.*)/i,
    pattern: /(#CHECK):*\s*((Min|Max)?(Lowest|Highest)?)\s*\(([^)]+)\)\s*,\s*(if.*)/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
  {
    // Condition list: #check: CONDITIONS (variableName)
    pattern: /(#CHECK):*\s*(CONDITIONS)\s*\(\s*((?:memory\.)?\w+)\s*\)/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
  {
    // PlayerHas: #check: PLAYERHAS ALL (reward1, reward2), if yes node_true, if no node_false
    pattern: /(#CHECK):*\s*(PLAYERHAS)\s*(ALL|ANY)?\s*\(([^)]+)\)\s*,\s*((?:if\s+)?(?:yes(?:\s+goto)?\s+)?(\w*))\s*,\s*((?:if\s+)?(?:no(?:\s+goto)?\s+)?(\w*))/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
  {
    pattern: /(#CHECK)[:\s]*/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyPremiumAnswerValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#PREMIUM):?\s*(\w*)/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyBonusContentValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#BONUS)(?=[:\s]|$):?\s*/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyEndingContentValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#ENDING)(?=[:\s]|$):?\s*/i,
    scope: [EpisodeTextColumnKey.NodeOrSpeaker, EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
];

/*
  REQ command groups:
  [1]=REQ|REQUIREMENT, [2]=remainder (everything after colon, parsed manually in _validateReqCommand)
*/
export const episodeTextImportCommandKeyReqValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#REQ(?:UIREMENT)?):?\s*(.*)/i,
    scope: [EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyStepVideoValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#VIDEO)(?:[:\s]+)?([^#]*)/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
];

export const episodeTextImportCommandKeyStepAchieveValue: EpisodeTextImportCommandKeyValue[] = [
  {
    pattern: /(#ACHIEVE)(?:[:\s]+)?([^#]*)/i,
    scope: [EpisodeTextColumnKey.Text, EpisodeTextColumnKey.Description],
  },
];
